import { FC } from "react";
import { Chip, Stack } from "@mui/material";
import AttachmentOutlinedIcon from "@mui/icons-material/AttachmentOutlined";
import { useAppSelector } from "../../../../../../../../store/hooks";
import { reportsDataPropertyByKeySelector } from "../../../../../../../../store/reports/selector/reportsDataPropertyByKeySelector";

export const ReportsDrawerNotificationsCustomMessageAfterMessage: FC = () => {
  const exportFileTypes =
    useAppSelector(reportsDataPropertyByKeySelector("export_file_types")) ?? [];

  return (
    <Stack direction="row" spacing={1}>
      {exportFileTypes.map((fileType) => (
        <Chip
          key={fileType}
          avatar={<AttachmentOutlinedIcon fontSize="small" />}
          label={`Resources.${fileType}`}
        />
      ))}
    </Stack>
  );
};
